import { expValEquals, UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { ff } from '@atlassian/jira-feature-flagging';

export const INVITE_PROMPT_ON_LINK_INSERT = 'invite_prompt_on_link_insert';
export const INVITE_PROMPT_ON_LINK_INSERT_V2 = 'invite_prompt_on_link_insert_v2';
export const INVITE_PROMPT_ON_LINK_INSERT_V3 = 'invite_prompt_on_link_insert_v3';

export type InvitePromptOnLinkFeatureFlag =
	| typeof INVITE_PROMPT_ON_LINK_INSERT
	| typeof INVITE_PROMPT_ON_LINK_INSERT_V2
	| typeof INVITE_PROMPT_ON_LINK_INSERT_V3;

export const SOURCE = {
	ISSUE_VIEW: 'issue-view',
	CREATE_ISSUE: 'create-issue',
	CREATE_LINK: 'create-link',
} as const;

export type Source = (typeof SOURCE)[keyof typeof SOURCE];

// eslint-disable-next-line jira/ff/inline-usage
export const isExperimentEnabled = (flagKey: InvitePromptOnLinkFeatureFlag) =>
	// eslint-disable-next-line jira/ff/static-feature-flags
	expValEquals(flagKey, 'cohort', 'variation');

export const isInviteOnLinkInsertV3Enabled = (shouldFireExposure = false): boolean => {
	if (!ff('statsig-guard-invite-prompt-on-link-insert-v-3', false)) return false;

	// eslint-disable-next-line jira/ff/unsafe-no-exposure
	const [expConfig, fireExposure] = UNSAFE_noExposureExp('invite_prompt_on_link_insert_v3');
	const cohort = expConfig.get('cohort', 'not-enrolled');
	if (shouldFireExposure) {
		fireExposure();
	}

	return cohort === 'variation';
};
